import api from '@/utils/api'

export const fetchPayments = (params) => {
  return api.get('/payments/', {params: params})
    .then(resp => {
      return (resp.data)
    })
}
export const fetchRunnerPayments = (runner, params) => {
  return api.get(`/runners/${runner.id}/payments/`, {params: params})
    .then(resp => {
      return (resp.data)
    })
}
export const fetchRunnerPayment = (runner, id) => {
  return api.get(`/runners/${runner.id}/payments/${id}/`)
    .then(resp => {
      return (resp.data)
    })
}
export const payRunnerPayment = (runner, obj) => {
  return api.post(`/runners/${runner.id}/payments/${obj.id}/pay/`)
    .then(resp => {
      return (resp.data)
    })
}
export const createPayment = (obj) => {
  return api.post('/payments/', obj)
    .then(resp => {
      return (resp.data)
    })
}

export const updatePayment = (obj) => {
  return api.put(`/payments/${obj.id}/`, obj)
    .then(resp => {
      return (resp.data)
    })
}

export const patchPayment = (obj) => {
  return api.patch(`/payments/${obj.id}/`, obj)
    .then(resp => {
      return (resp.data)
    })
}

export const deletePayment = (obj) => {
  return api.delete(`/payments/${obj.id}/`, obj)
    .then(resp => {
      return (resp.data)
    })
}

export const paidPayment = (id, type) => {
  return api.post(`/payments/${id}/paid/`, {'payment_type': type})
    .then(resp => {
      return (resp.data)
    })
}

export const unpaidPayment = (id) => {
  return api.delete(`/payments/${id}/paid/`)
    .then(resp => {
      return (resp.data)
    })
}

export const downalodPaymentDocument = (obj) => {
  return api.get(`/payments/${obj.id}/download/`)
    .then(resp => {
      return (resp.data)
    })
}



// WEBPACK FOOTER //
// ./src/payments/api.js